import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from './general.service';
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {IConsoleApplication} from '../views/console-applications/ConsoleApplication';
import {StoreService} from './store.service';
import {EDIServices} from './edi.services';
import {IResponse} from '../model/server_response';

@Injectable()
export class ConsoleApplicationService
    extends GeneralService
        implements EDIServices<Observable<IConsoleApplication>, IConsoleApplication, number> {

    private store: StoreService;

    constructor(protected http: HttpClient) {
        super(http);

        this.store = new StoreService('consoleApplications', 'id');
    }

    getStore(): StoreService {
        return this.store;
    }

    getById(id: number): Observable<IConsoleApplication> {

        if (id === 0) {
            return Observable.of(this.initialize());
        }

        const url = `${this.apiUrl}/console-applications/get/${id}`;
        return this.http.get(url)
            .map(
                data => this.extractPayload(data)
            )
            .catch(this.handleError);
    }

    save(consoleApplication: IConsoleApplication, isCreate: boolean): Observable<IConsoleApplication> {
        if (consoleApplication.CL1_ID === 0 || isCreate) {
            return this.create(consoleApplication);
        }
        return this.update(consoleApplication);
    }

    public getConsoleApplications(page): Observable<IResponse<IConsoleApplication>> {
        const current_page = page.pageNumber + 1;
        let params = new HttpParams();
        params = params.append('perPage', page.size);
        params = params.append('page', current_page);
        if (!_.isUndefined(page.sortParams)) {
            for (const key of Object.keys(page.sortParams)) {
                const value = page.sortParams[key];
                params = params.append('sort', key + ',' + value );
            }
        }
        if (!_.isUndefined(page.filterParams)) {
            for (const key of Object.keys(page.filterParams)) {
                const value = page.filterParams[key];
                if (value && value !== '') {
                    params = params.append('filter', key + ',' + value );
                }
            }
        }
        return this.http.get<IResponse<IConsoleApplication>>(this.apiUrl + '/console-applications', { params : params });
    }

    private create(consoleApplication: IConsoleApplication): Observable<IConsoleApplication> {
        return this.http.post(this.apiUrl + '/console-applications', consoleApplication)
            .catch(this.handleError);
    }

    private update(consoleApplication: IConsoleApplication): Observable<IConsoleApplication> {
        const url = `${this.apiUrl + '/console-applications'}/update/${consoleApplication.CL1_ID}`;
        return this.http.put(url, consoleApplication)
            .do(data => this.store.update(data))
            .catch(this.handleError);
    }

    public delete(id: number) {
        return this.http.delete<any>(this.apiUrl + '/console-applications/delete/' + id);
    }

    public getAllConsoleApplications() {
        return JSON.parse(localStorage.getItem('consoleApplications')) || [];
    }

    public refreshToken( token ) {
        const url = `${this.apiUrl + '/console-applications/refresh-token/'}`;
        return this.http.put(url, {
                token: token
            }).catch(this.handleError);
    }

    public getLogText(): Observable<any> {
        const url = `${this.apiUrl}/console-applications/get-log-text`;
        return this.http.get(url)
            .catch(this.handleError);
    }

    public getCommandActions(): Observable<string> {
        const url = `${this.apiUrl}/console-applications/get-command-actions`;
        return this.http.get(url)
            .catch(this.handleError);
    }

    initialize(): IConsoleApplication {
        // Return an initialized object
        return {
            CL1_ID : 0,
            CL1_NAME : '',
            commandAction : ['', ''],
            CL1_COMMAND: '',
            CL1_FUNCTION: '',
            CL1_PARAMS : {},
            CL1_RUN_STATUS : 0,
            CL1_DESCRIPTION : '',
            CL1_LAST_RUN : '',
            CL1_PID : '',
            CL1_EXIT_CODE : 0,
            CL1_LAST_RUN_COMPLETE : '',
            CL1_INTERVAL_MINUTES : 1,
            CL1_ENABLED : 1,
            errors: null
        };
    }

    preloadData(): Observable<any> {
        return this.http.get(this.apiUrl + '/console-applications/preload');
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/console-application.service.ts